import type { RouteWaypoint } from "../../../ReviewPage/hooks/useCircuitCablePaths/types";
import type { BuildAssignTargets } from "./types";

const squaredDistance = (a: RouteWaypoint, b: RouteWaypoint): number =>
  (a.x - b.x) ** 2 + (a.y - b.y) ** 2;

export const buildAssignTargets: BuildAssignTargets = ({
  selection,
  rows,
  feedingBoardByCircuit,
  categoriesByBoard,
  devicePositionsByCircuit,
  boardPositions,
  colorOf,
}) => {
  const category = selection.categories[0] ?? null;
  const feeds = (board: string | null) =>
    Boolean(board) && (!category || (categoriesByBoard[board as string] ?? []).includes(category));
  const centre = selection.centre;

  const circuits = rows
    .flatMap((row) => {
      if (!row.circuit) return [];
      const boardLabel = feedingBoardByCircuit[row.circuit] ?? null;
      if (!feeds(boardLabel)) return [];
      const positions = devicePositionsByCircuit[row.circuit] ?? [];
      const distance =
        centre && positions.length
          ? Math.min(...positions.map((at) => squaredDistance(at, centre)))
          : Number.POSITIVE_INFINITY;
      return [{ circuitId: row.circuit, label: row.text || row.circuit, boardLabel, color: colorOf(row.circuit), distance }];
    })
    .sort((a, b) => a.distance - b.distance || a.label.localeCompare(b.label))
    .map(({ distance: _distance, ...target }) => target);

  const boards = Object.keys(categoriesByBoard)
    .filter((board) => feeds(board) && boardPositions[board])
    .sort((a, b) =>
      centre ? squaredDistance(boardPositions[a], centre) - squaredDistance(boardPositions[b], centre) : 0,
    );

  return { circuits, boards };
};
